
export const FETCH_VERIFIED = "[MRT] FETCH_VERIFIED";
export const FETCH_VERIFIED_START = "[MRT] FETCH_VERIFIED_START";
export const FETCH_VERIFIED_SUCCESS = "[MRT] FETCH_VERIFIED_SUCCESS";
export const FETCH_VERIFIED_ERROR = "[MRT] FETCH_VERIFIED_ERROR";

export const SET_MRT_VERIFIED_FILTER = "[MRT] SET_MRT_VERIFIED_FILTER";
export const SET_VERIFIED_PAGINATION = "[MRT] SET_VERIFIED_PAGINATION";

export const VIEW_VERIFIED_VISIT_LOADING_START = "[MRT] VIEW_VERIFIED_VISIT_LOADING_START";
export const VIEW_VERIFIED_VISIT_LOADING_END = "[MRT] VIEW_VERIFIED_VISIT_LOADING_END";
export const RESET_VERIFIED_FILTER = "[MRT] RESET_VERIFIED_FILTER";

export const fetchVerified = (payload) => {
    return {
        type: FETCH_VERIFIED,
        payload
    };
};

export const setMrtVerifiedFilter = (searchFilter, sortConditions, skippedVisits) => {
    return {
        type: SET_MRT_VERIFIED_FILTER,
        payload: {
            searchFilter,
            sortConditions,
            skippedVisits
        }
    };
}

export const resetVerifiedFilter = () => {
    return {
        type: RESET_VERIFIED_FILTER,
    };
}


